module.exports = __webpack_public_path__ + "static/media/Q_2_25.16e2a910.jpg";